// Third-party
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

// Components
import Stack from '@mui/material/Stack';
import { mdiChevronDown } from '@mdi/js';
import Icon from '@mdi/react';
import Button from '@mui/material/Button';
import { BaseBreadcrumbs, BaseButtonMenu } from '@mgm/common/components/base';
import { Calendar } from './Calendar';
import { DeleteShiftDialog, CreateEditScheduleShift } from './Shared/components';
import { DayOffNav, DeleteTimeOffDialog } from './Calendar/components';
import { useCommonSchedules, useSchedulePermissions } from './Shared/hooks';

const CalendarView = () => {
  const { t } = useTranslation(['timesheets', 'schedule', 'team', 'common']);
  const { addShiftItems, addTimeoff } = useCommonSchedules();

  const { schedulePermissions } = useSchedulePermissions();

  return (
    <Box>
      <BaseBreadcrumbs
        heading={t('calendar', { ns: 'nav' })}
        links={[
          { name: t('schedules', { ns: 'nav' }), href: '/schedules/monthly' },
          { name: t('calendar', { ns: 'nav' }), href: '/schedules/monthly' },
        ]}
        action={(
          <Stack alignItems="center" spacing={2} direction="row">
            <Button onClick={addTimeoff} variant="outlined">
              {t('timeoff', { ns: 'schedule' })}
            </Button>
            {schedulePermissions.isAllowManage && (
            <BaseButtonMenu
              isRemoveBtnHover={false}
              buttonProps={{
                children: t('addShift'),
                endIcon: (
                  <Icon path={mdiChevronDown} size={0.8} />
                ),
                variant: 'contained',
              }}
              listProps={{
                items: addShiftItems,
                sx: {
                  width: 125,
                },
                itemfontsize: 12,
              }}
            />
            )}
          </Stack>
        )}
      />

      <Calendar />

      <CreateEditScheduleShift />
      <DeleteShiftDialog />
      <DeleteTimeOffDialog />
      <DayOffNav />
    </Box>
  );
};

export {
  CalendarView,
};
